var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[(_vm.$slots['total'])?[_c('div',{staticClass:"text-sm"},[_c('span',{staticClass:"mr-1 font-light"},[_vm._v("Всего:")]),_vm._t("total")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }